import { last, orderBy } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import ColorfulCard from '../../../components/card/ColorfulCard'
import DtoEvent from '../../../events/dto/DtoEvent'
import { STATION_NAME_ASSOCIATION } from '../../../station/constants/StationConstants'
import { getEventColor } from '../../../utils/ColorUtil'
import { getDateWithHour } from '../../../utils/DateUtil'
import { getSiteUrl } from '../../../utils/mapUtils/SiteTypes'
import { getStations } from '../../../utils/StationUtils'
import { getLabel } from '../../../utils/StoreUtils'
import EventCard from './EventCard'
import { Grid } from '@mui/material'

const LastEventPanel = ({
    stationId,
    stationType,
    events,
}) => {
    const {
        pluviometers,
        piezometers,
        hydrometricStations,
        qualitometers,
        productionUnits,
        distributionUnits,
        installations,
        cities,
    } = useSelector(store => ({
        pluviometers: store.PluviometryReducer.pluviometers,
        piezometers: store.PiezometryReducer.piezometersLight,
        hydrometricStations: store.HydrometryReducer.hydrometricStations,
        qualitometers: store.QualityReducer.qualitometersLight,
        productionUnits: store.ProductionUnitReducer.productionUnits,
        distributionUnits: store.DistributionUnitReducer.distributionUnits,
        installations: store.InstallationReducer.installations,
        cities: store.CityReducer.cities,
    }), shallowEqual)
    const stations = { pluviometers, piezometers, hydrometricStations, qualitometers, productionUnits, distributionUnits, installations }
    if (events?.length) {
        const data = last(orderBy(events.filter(e => (e.eventType !== 'T' || !e.problem) && e.date), e => getDateWithHour(e.date, e.eventHour).valueOf())) // on n'affiche pas les évènements techniques
        if (data) {
            const station = getStations(stations, data.stationType).find(s => s.code === data.stationCode) || null
            return (
                <ColorfulCard color={getEventColor(data.eventType)}>
                    {
                        !!station && data.stationCode !== stationId && (
                            <>
                                <Grid container spacing={1} sx={{ paddingLeft: '25px', paddingTop: '5px' }} alignItems='center'>
                                    <img src={getSiteUrl(STATION_NAME_ASSOCIATION[station.typeName])} style={{ maxWidth: '25px', height: '25px' }}/>
                                    {`${station.code} ${getLabel(cities, station.townCode)} - ${station.name}`}
                                </Grid>
                                <hr />
                            </>
                        )
                    }
                    <EventCard
                        event={data}
                        small
                        link={`/station/${data.stationType || stationType}/${data.stationId || stationId}/event/`}
                        showStationInfo={['productionUnit', 'distributionUnit', 'installation'].includes(stationType)}
                        stationType={stationType}
                    />
                </ColorfulCard>
            )
        }
        return null
    }
    return null
}

LastEventPanel.propTypes = {
    stationId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    stationType: PropTypes.string,
    events: PropTypes.arrayOf(PropTypes.instanceOf(DtoEvent)),
}

export default LastEventPanel
